import ChevronLeft from '../src/ChevronLeft/index.tsx';
export default ChevronLeft;
